import React, { useRef, useCallback, useState } from 'react';
import { FiMail, FiLock, FiLogIn } from 'react-icons/fi';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import logoImg from '../../assets/logo.svg';

import Button from '../../components/Button';
import Input from '../../components/Input';
import getValidationErrors from '../../utils/getValidationErros';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import {
  Container,
  ContentArea,
  ContentBox,
  Content,
  Background,
} from './styles';

interface SignInFormData {
  email: string;
  password: string;
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { addToast } = useToast();
  const { signIn } = useAuth();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      if (isSubmitting) return;
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, { abortEarly: false });

        setIsSubmitting(true);
        await signIn({ email: data.email, password: data.password });

        history.push('/dashboard');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      } finally {
        setIsSubmitting(false);
      }
    },
    [history, signIn, addToast, isSubmitting],
  );

  return (
    <Container>
      <ContentArea>
        <ContentBox>
          <Content>
            <img src={logoImg} alt="MyFinances" />

            <Form ref={formRef} onSubmit={handleSubmit}>
              <h1>Faça seu login</h1>
              <Input name="email" icon={FiMail} placeholder="E-mail" />
              <Input
                name="password"
                icon={FiLock}
                placeholder="Senha"
                type="password"
              />
              <Button type="submit" loading={isSubmitting} disabled={isSubmitting}>
                Login
              </Button>
              {/* <a href="forgot">Esqueci minha senha</a> */}
            </Form>

            <Link to="/signup">
              <FiLogIn />
              Criar conta
            </Link>
          </Content>
        </ContentBox>
      </ContentArea>
      <Background>
        <a href="https://br.freepik.com/vectors/fundo">
          Fundo vetor criado por freepik - br.freepik.com
        </a>
      </Background>
    </Container>
  );
};

export default SignIn;
